import ApiClient from './ApiClient'
import { Banner } from '../types/Entities/BannerType';

const getBannerData = async (apiClient: ApiClient) => {
    return apiClient
      .get<Array<Banner>>(`BannerInfo/getallbannerinfoforcore`)
      .catch(error => { throw error });
  }

const BannerApi = {
    getBannerData
  }
  export default BannerApi